const CLASS_BODY_DISABLED = 'is-scroll-disabled';

export default class Body {

    scrollDisabled = false;
    _instance;

    static instance(){
        if(this._instance) return this._instance;
        return this._instance = new this();
    }

    constructor(){
        this.body = document.body;
    }

    disableScroll() {
        if(this.scrollDisabled) return;
        this.scrollDisabled = true;
        this.body.classList.add(CLASS_BODY_DISABLED);
    }

    enableScroll() {
        if(!this.scrollDisabled) return;
        this.scrollDisabled = false;
        this.body.classList.remove(CLASS_BODY_DISABLED);
    }
}


// WEBPACK FOOTER //
// ./public/assets/scripts/components/body.js